var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useEffect, useState } from 'react';
function useStorage(key, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = '';
  }
  var _a = __read(useState(localStorage.getItem(key) || defaultValue), 2),
    storedValue = _a[0],
    setStoredValue = _a[1];
  var setStorageValue = function setStorageValue(value) {
    localStorage.setItem(key, value);
    if (value !== storedValue) {
      setStoredValue(value);
    }
  };
  var removeStorage = function removeStorage() {
    localStorage.removeItem(key);
  };
  useEffect(function () {
    var storageValue = localStorage.getItem(key);
    if (storageValue) {
      setStoredValue(storageValue);
    }
  }, []);
  return [storedValue, setStorageValue, removeStorage];
}
export default useStorage;